import { apiRoutes } from "../config-data/apiRoutes";
import { parseCityRumors } from "../adapters/cityRumors.adapter";

export const LOAD_CITY_RUMORS = 'LOAD_CITY_RUMORS';

export async function loadCityRumors() {
	let apiResult = await fetch(apiRoutes.CITY_RUMORS);
	let jsonResponse = await apiResult.json();
	const parsedResponse = parseCityRumors(jsonResponse);

	return {
		type: LOAD_CITY_RUMORS,
		payload: {
			cityRumors: parsedResponse
		}
	}
}


// WEBPACK FOOTER //
// ./src/actions/cityRumors.actions.js